export default __webpack_public_path__ + "static/ser-hero-logo-8334b9131645fb21c7132d57b3e344e1.png";